import { useState, useEffect } from 'react';
import COLORS from '../lib/colors.js';

const EXPECTED_HASH = 'bb2f3ebf48dd2a3098fb11684b41af6c0e548e5a1569d74614cde638d775e6c8';
const AUTH_KEY = 'simulator_auth';

async function sha256(message) {
  const msgBuffer = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
}

function PasswordGate({ children }) {
  const [authed, setAuthed] = useState(false);
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (sessionStorage.getItem(AUTH_KEY) === 'true') {
      setAuthed(true);
    }
    setChecking(false);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const hash = await sha256(password);
    if (hash === EXPECTED_HASH) {
      sessionStorage.setItem(AUTH_KEY, 'true');
      setAuthed(true);
    } else {
      setError('Incorrect password');
      setPassword('');
    }
  };

  if (checking) return null;
  if (authed) return children;

  return (
    <div style={{
      minHeight: '100vh', background: COLORS.bg, display: 'flex',
      alignItems: 'center', justifyContent: 'center', fontFamily: "'Inter', sans-serif",
    }}>
      <form onSubmit={handleSubmit} style={{
        background: COLORS.surface, padding: 40, borderRadius: 12,
        border: `1px solid ${COLORS.border}`, maxWidth: 360, width: '100%',
      }}>
        <h2 style={{ color: COLORS.ink, margin: '0 0 8px', fontSize: 20, fontFamily: "'Shippori Mincho B1', serif" }}>
          Yield Simulator
        </h2>
        <p style={{ color: COLORS.textSecondary, margin: '0 0 24px', fontSize: 14 }}>
          Enter password to access
        </p>
        <div style={{ position: 'relative', marginBottom: 12 }}>
          <input
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            autoFocus
            style={{
              width: '100%', padding: '10px 36px 10px 12px', borderRadius: 8,
              border: `1px solid ${COLORS.borderDark}`, background: COLORS.surfaceAlt,
              color: COLORS.ink, fontSize: 14, outline: 'none',
              boxSizing: 'border-box',
            }}
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
              background: 'none', border: 'none', cursor: 'pointer', padding: 4,
              color: COLORS.textSecondary, display: 'flex', alignItems: 'center',
            }}
            tabIndex={-1}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              {showPassword ? (
                <>
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                  <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                  <line x1="1" y1="1" x2="23" y2="23" />
                </>
              ) : (
                <>
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                  <circle cx="12" cy="12" r="3" />
                </>
              )}
            </svg>
          </button>
        </div>
        {error && (
          <p style={{ color: COLORS.negative, fontSize: 13, margin: '0 0 12px' }}>
            {error}
          </p>
        )}
        <button type="submit" style={{
          width: '100%', padding: '10px 0', borderRadius: 8,
          border: 'none', background: COLORS.accent, color: COLORS.bg,
          fontSize: 14, fontWeight: 600, cursor: 'pointer',
        }}>
          Access Simulator
        </button>
      </form>
    </div>
  );
}

export default PasswordGate;
